// extracted by mini-css-extract-plugin
export default {"content_heading":"MenuItem_content_heading__jJ1+3"};